import { NativeBridge } from "./parentAppBridge";

declare global {
  interface Window {
    NativeBridge?: typeof NativeBridge;
  }
}

if (!window.NativeBridge) {
  window.NativeBridge = NativeBridge;
  console.log("[parentAppBridgeInstall] NativeBridge installed");
}
